module.exports = "/to_the_arctic_for_practice/_next/static/videos/12-061151abf9f54b7804c3583ec4f940c7.mp4";